module.exports = __webpack_public_path__ + "c46d71fb8c748ca64bf338fff154c9c1.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/icon-document.svg
// module id = 987
// module chunks = 69